import type {
  ContractIdData,
  ContractIdSelectionPayload,
} from '@src/generic-components/ContractIdSelectionModal/types/ContractIdModal.types';

export interface ContractIdEditorState {
  isOpen: boolean;
  contractIds: ContractIdData[];
  selectedIds: string[];
  invalidContractIds: string[];
  isLoading: boolean;
  error: string | null;
}

export interface OpenContractIdEditorPayload {
  contractIds: ContractIdData[];
  selectedIds: string[];
}

export type ContractIdSelectionAppliedPayload = ContractIdSelectionPayload;

export const initialContractIdEditorState: ContractIdEditorState = {
  isOpen: false,
  contractIds: [],
  selectedIds: [],
  invalidContractIds: [],
  isLoading: false,
  error: null,
};
